import BaseClass from "../../libs/base/BaseClass";
import Util from "../../libs/util/Util";
import PriceSliderClass from "../common/PriceSliderClass";
import HotelSearchAreaClass from "./HotelSearchAreaClass";
import CheckBoxLimitClass from "../common/CheckBoxLimitClass";
import LtikeCommon from "../common/LtikeCommon";
import gsap from "gsap";

/**
 * ホテル一覧用　絞り込み検索
 */
export default class ToolsClass extends BaseClass{
    constructor(_target){
        super();
        this.name = "ToolsClass";

        this.EVENT_CHANGE = "eventChange";

        this.target = _target;

        this.isToolsBtnVisible = false;

        this.onChangeListener = this.onChange.bind(this);

        this.timerId;
    }

    onCreate() {
        this.blocks = $(".block",this.target);
        this.loader = $(".css_loader",this.target);
        this.inputInsertTarget = $(".input_insert_target",this.form);
    }

    onResize() {
        if(this.slider) this.slider.onResize();
    }

    onSetDefaultData(_data){
        //console.log("onSetDefaultData",_data);

        this.catalogid = _data.catalogid;
        this.accesskey = _data.accesskey;

        let filter;
        try{
            filter = _data.catalogdata.hotel.hotel.filter;
        } catch (e){
            window.alert("ホテル一覧：filterの取得に失敗しました");
            return;
        }
        //console.log(filter,this.target);

        $(".js-slider",this.target).attr({"data-a":filter.min,"data-b":filter.max});

        //ホテルランク
        let rankHtml = '';
        rankHtml += '<ul>';

        for(let i=5;i>0;i--){
            if(filter["start"+i]) {
                let n = filter["start"+i];
                rankHtml += '<li><label class="css_checkbox"><input type="checkbox" name="hfst'+i+'" value="1"><span>';
                rankHtml += '<span class="icon"></span><span class="txt"><span class="css_star" data-val="'+i+'"></span>('+n+')</span></span></label></li>';
            }
        }
        rankHtml += '</ul>';
        $('.block.rank',this.target).append(rankHtml);

        //施設タイプ
        if(filter.hotelfacility){
            const typeData = Util.checkItems(filter.hotelfacility.facilitylist.item);
            //console.log("typeData",typeData,typeof typeData);
            let typeHtml = '';
            typeHtml += '<ul>';
            let typeArr = [];
            if(typeData["0"]){
                typeArr = typeData;
            } else {
                typeArr.push(typeData);
            }
            for(let k in typeArr){
                const d = typeArr[k];
                typeHtml += '<li><label class="css_checkbox"><input type="checkbox" name="hffacility[]" value="'+d.code+'">';
                typeHtml += '<span><span class="icon"></span><span class="txt">'+d.name+'('+d.number+')</span></span></label></li>';
            }
            typeHtml += '</ul>';
            $('.block.type',this.target).append(typeHtml);
        }


        //エリア
        if(filter.hotellocation){
            const areaData = Util.checkItems(filter.hotellocation.locationlist.item);
            //console.log(areaData);
            let areaHtmlL1 = '';
            areaHtmlL1 += '<ul>';
            let areaL1Max = (areaData.length >= 2)? 2 : areaData.length;
            for(let i=0;i<areaL1Max;i++){
                const d = areaData[i];
                areaHtmlL1 += '<li><label class="css_checkbox"><input type="checkbox" name="hfarea[]" value="'+d.id+'">';
                areaHtmlL1 += '<span><span class="icon"></span><span class="txt">'+d.location+'('+d.number+')</span></span></label></li>';
            }
            areaHtmlL1 += '</ul>';
            $('.block.area .l1',this.target).append(areaHtmlL1);

            if(areaData.length > 2) {
                let areaHtmlL2 = '';
                areaHtmlL2 += '<ul>';
                for(let i=2;i<areaData.length;i++){
                    const d = areaData[i];
                    areaHtmlL2 += '<li><label class="css_checkbox"><input type="checkbox" name="hfarea[]" value="'+d.id+'">';
                    areaHtmlL2 += '<span><span class="icon"></span><span class="txt">'+d.location+'('+d.number+')</span></span></label></li>';
                }
                areaHtmlL2 += '</ul>';
                $('.block.area .l2',this.target).append(areaHtmlL2);
            } else {
                $('.block.area .more',this.target).css({display:"none"});
            }
        } else {
            $('.block.area .more',this.target).css({display:"none"});
        }


        $("input",this.target).on("change",this.onChangeListener);
        $("label.css_radio_button",this.target).on("click",this.onChangeListener);
        $("label.css_checkbox",this.target).on("click",this.onChangeListener);

        this.checkboxLimit = new CheckBoxLimitClass($(".block.area",this.target),3);
        this.checkboxLimit.onCreate();

        this.slider = new PriceSliderClass($(".js-slider",this.target));
        this.slider.onCreate();
        this.slider.on(this.slider.EVENT_CHANGE,()=>{
            this.onChange();
        });
        this.onChange();
    }

    onReset(){
        $("input",this.target).prop("checked",false);
        this.slider.onReset();
        this.onChange();
    }

    onChange(){
        //console.log(this.name,"onChange");

        clearTimeout(this.timerId);
        this.timerId = setTimeout(()=>{
            this.onToolsCheck();
        },10);
    }

    onToolsCheck(){
        let flag = false;
        $("input",this.target).each(function(){
            if($(this).prop("checked")){
                flag = true;
                return true;
            }
        });

        if(this.slider.getChangeFlag()) {
            flag = true;
        }

        this.jq.trigger(this.EVENT_CHANGE,{flag:flag});
    }
}